<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-menu
		:close-on-content-click="false"
		:nudge-right="40"
		full-width
		lazy
		min-width="290px"
		offset-y
		transition="scale-transition"
		v-model="open"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				browser-autocomplete="off"
				:disabled="disabled"
				:label=label
				prepend-icon="event"
				readonly
				v-model="valueInternal"
				:rules="rules"
				v-on="on"
				aria-label="label for text"
			></v-text-field>
		</template>

		<v-date-picker
			no-title
			scrollable
			v-model="valueInternal"
			:first-day-of-week="1"
			@input="closeDatePicker"
			:min="min"
			:max="max"
			locale="pl-PL"
		></v-date-picker>
	</v-menu>
</template>

<script>
	export default {
		name: "egrantyDatePicker",

		data() {
			return {
				open: false,
				valueInternal: "",
				validationRules: {
					required: function (value) {
						if (value === null || value === "" || value === undefined) return "To pole jest wymagane.";
						return true;
					}
				},
			};
		},

		computed: {
			rules () {
				let array = [];
				if (this.required) {
					array.push(this.validationRules.required);
				}
				return array;
			},
		},

		methods: {
			closeDatePicker() {
				this.open = false;
				this.$emit("input", this.valueInternal);
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.valueInternal = val;
				},
			},
		},

		props: {
			required: {
				type: Boolean,
				default: false,
			},
			value: String,
			label: String,
			min: {
				type: String,
				default: ""
			},
			max: {
				type: String,
				default: ""
			},
			disabled: {
				default: false
			}
		},
	};
</script>

<style scoped>

</style>
